var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document"},[(_vm.$route.name === 'policy')?_c('Policy'):_vm._e(),(_vm.$route.name === 'agree')?_c('Agree'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }